const faqItems = [
  {
    question: "How does Connct work?",
    answer:
      "The Connct card has an NFC chip inside that wirelessly sends your information. If you tap the card on compatible phones, a link will open up with all your information. Ready to be saved to the phone. For older phones that don't have NFC, there is a QR code on the back of your digital card.",
  },
  {
    question: "Do I need to pay a monthly fee?",
    answer:
      "You do not require a monthly fee. Just a one-time payment for the digital business card. However, the upgrade to advanced features requires a subscription fee which is completely optional.",
  },
  {
    question: "How long will my order take to ship?",
    answer: "It will take 3-5 business days after the order is placed.",
  },
  {
    question:
      "Does the other person need the card or an app for you to share information?",
    answer:
      "No. The other person doesn't have to have the card or the app. They just need a phone compatible with Connct, which most phones usually are. But in the rare case they don't, just share your QR code to send all your important info via your Connct profile.",
  },
  {
    question: "What phones are compatible with the electronic business card?",
    answer:
      "Almost all the latest Android phones and iPhones after 7 are compatible with Connct. The compatible device list is on the Connct website.",
  },
  {
    question: "Can I get a custom business card design for my company?",
    answer:
      "Absolutely. Connct has an in-house designer that will take care of all the customization for your Connct card as per your brand guidelines.",
  },
  {
    question: "How do I activate my digital card?",
    answer:
      "Go to Settings. Click on Activate account. Enter the activation key (you will receive it in your email, or you will get the activation key with your Connct card). Then go to Link card, click Link Now, and place your Connct card behind the phone until you get the success message.",
  },
  {
    question: "What is the Pro version?",
    answer:
      "With the Pro version, you unlock premium features in addition to the standard features: switching between different profiles, varied profile themes, custom icons and titles, multiple social media profiles, a media gallery, and advanced analytics.",
  },
  {
    question: "What is My Contact?",
    answer:
      "My Contact is the list of all your connections who have shared their information with you on your Connct profile. You can download all the contacts and integrate it with your CRM for better conversion.",
  },
  {
    question: "How do I share my info if they don't have NFC?",
    answer:
      "You can share your contact information by scanning the QR code printed on your digital visiting card or opening the QR code from the app installed on your phone. Alternatively, you can share your profile via text, email, or any social media with a link.",
  },
  {
    question: "Can I change my details?",
    answer:
      "Yes, you can change your details in real-time to fit every interaction. You can also enable and disable any details that you want to share.",
  },
  {
    question: "Is my data secure?",
    answer:
      "Built on advanced tech frameworks, Connct prioritizes data security ensuring no unauthorized access to your data. The NFC card only works when you tap it on a compatible device and shares only what you allow.",
  },
];

export const faqPageJsonLd = {
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
};
